<template>
  <div class="mainContainer">
    <div class="tabs">
      <div @click="typeFun(0)" class="left" :class="{ active: planType === 0 }">公路</div>
      <div @click="typeFun(1)" :class="{ active: planType === 1 }">水路</div>
      <div @click="typeFun(2)" :class="{ active: planType === 2 }">港口</div>
      <div @click="typeFun(3)" class="right" :class="{ active: planType === 3 }">仓库及其它</div>
    </div>
    <div class="componentsContainer">
      <highWay v-show="planType === 0"/>
      <port v-show="planType === 2"/>
      <warehouse v-show="planType === 3"/>
      <water v-show="planType === 1"/>
    </div>
  </div>
</template>

<script>
import highWay from "@/views/settle/settlement/components/highWay";
import port from "@/views/settle/settlement/components/port"
import warehouse from "@/views/settle/settlement/components/warehouse";
import water from "@/views/settle/settlement/components/water"
export default {
  components: {
    highWay,
    port,
    warehouse,
    water
  },

  data() {
    return {
      planType:0,
    };
  },
  methods: {
    typeFun(val) {
      this.planType = val;
    },
  }
}
</script>



<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  .tabs {
    float: left;
    margin-left: 20px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 384px;
    margin-bottom: 20px;
    div {
      //background: #ccc;
      width: 120px;
      height: 30px;
      line-height: 30px;
      color: #48599E;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid #48599E;
      font-weight: 700;
      transition: all .3s;
    }
    .left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    .right {
      width: 160px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .active {
      background: #48599E;
      color: #fff;
    }
  }
  .componentsContainer{
    width:100%;
  }
  ::v-deep{
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }
    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      top:9px;
    }
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
